exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-check-invoice-ids[data-v-141b9e61]{cursor:pointer;width:15px;height:15px;margin-left:6px}", ""]);

// exports
